import {Html , useProgress} from '@react-three/drei';

const CanvasLoader = () =>{
    const { progress } = useProgress();
    return (
        <Html
            as = 'div'
            center
        >
            <p
                style={{
                    fontSize: 14,
                    color: 'white',
                    fontWeight: 800,
                }}
            >
                {progress.toFixed(2)}%
            </p>
        </Html>
    )
}

export default CanvasLoader